document.addEventListener('DOMContentLoaded', function () {
	const homeNewsContainers = document.querySelectorAll('.homeNewsContainer');
	homeNewsContainers.forEach(function (container) {
		const posts = container.querySelectorAll('.homeNews .post');
		const imagesWrapper = container.querySelector('.homeNewsImages');
		const images = imagesWrapper.querySelectorAll('.post');

		const listener = (post) => {
			const id = post.dataset.id;
			[...images, ...posts].forEach(post => {
				if (post.dataset.id === id) {
					post.classList.add('focus');
				} else {
					post.classList.remove('focus');
				}
			});
		}

		posts.forEach((post) => {
			post.addEventListener('click', listener.bind(null, post));
			post.addEventListener('mouseover', listener.bind(null, post));
			post.addEventListener('focus', listener.bind(null, post));
		});
		if (posts.item(0)) {
			posts.item(0).classList.add('focus');
			posts.item(0).dispatchEvent(new Event('mouseover'));
		}


		// Throttle using requestAnimationFrame
		let ticking = false;
		const threshold = 0.5;
		const updateFocusOnScroll = () => {
			// Only apply when the images wrapper is sticky (mobile breakpoint)
			const isSticky = getComputedStyle(imagesWrapper).position === 'sticky';
			if (!isSticky) { return; }
			const imagesBottom = imagesWrapper.getBoundingClientRect().bottom;
			let activePost = null;
			for (const p of posts) {
				const r = p.getBoundingClientRect();
				// Post overlapping the bottom edge of the sticky image area
				if (r.top <= imagesBottom + 20 && r.bottom >= imagesBottom + 20) {
					activePost = p;
					break;
				}
			}
			if (!activePost) { return; }
			// Apply focus only to the active post & its corresponding image
			listener(activePost);
		};

		const onScroll = () => {
			if (!ticking) {
				ticking = true;
				requestAnimationFrame(() => {
					updateFocusOnScroll();
					ticking = false;
				});
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll); // re-evaluate stickiness on resize
		// Run once on load
		updateFocusOnScroll();
	});

	$(document).on('click', 'a.clipboard', function () {
		const $a = $(this);
		const link = $a.data('link');
		if (navigator.share) {
			navigator.share({
					title: 'Szélrózsa',
					text: document.title,
					url: $a.data('clipboard-url'),
				})
				.then(() => console.log('Successful share'))
				.catch(error => console.log('Error sharing:', error));
		} else {
			navigator.clipboard.writeText(link);
			$a.after('<span class="clipboard-feedback d-inline">Link vágólapra másolva!</span>');
			setTimeout(function () {
				$a.siblings('span.clipboard-feedback ').remove();
			}, 3000);
		}
	});
});






